import React from "react";


const TermsandCondition = () => {
    return (
        <>
            <section class="blog about-blog">
                <div class="container">
                    {/* <div class="blog-bradcrum">
                        <span><a href="/home">Home</a></span>
                        <span class="devider">/</span>
                        <span><a href="#">Terms and Condition</a></span>
                    </div> */}
                    <div class="blog-heading about-heading">
                        <h1 class="heading">Terms and Condition</h1>
                    </div>
                </div>
            </section>

            <section class="product privacy footer-padding">
                <div class="container">
                    <div class="privacy-section">
                    <div class="policy">
                    
                            <p class="policy-details">Please read these terms and conditions ("terms and conditions", "terms") carefully before using www.grocji.com website (“website”, "service") operated by Grocji Pvt Ltd ("us", 'we", "our").</p>
                        </div>

                        <div class="policy">
                            <h5 class="intro-heading">Conditions of use</h5>
                            <p class="policy-details">By using this website, you certify that you have read and reviewed this Agreement and that you agree to comply with its terms. If you do not want to be bound by the terms of this Agreement, you are advised to stop using the website accordingly. Grocji only grants use and access of this website, its products, and its services to those who have accepted its terms.</p>
                        </div>
                        <div class="policy">
                            <h5 class="intro-heading">Privacy policy</h5>
                            <p class="policy-details">Before you continue using our website, we advise you to read our privacy policy regarding our user data collection. It will help you better understand our practices.
                            </p>
                            <div class="policy-features">
                                <h5 class="intro-heading">Age restriction</h5>
                                <p class="policy-details">You must be at least 18 (eighteen) years of age before you can use this website. By using this website, you warrant that you are at least 18 years of age and you may legally adhere to this Agreement. Groji Pvt Ltd assumes no responsibility for liabilities related to age misrepresentation.
                            </p>
                            </div>
                        </div>
                        <div class="policy">
                            <h5 class="intro-heading">Intellectual property</h5>
                            <p class="policy-details">You agree that all materials, products, and services provided on this website are the property of Grocji Pvt Ltd, its affiliates, directors, officers, employees, agents, suppliers, or licensors including all copyrights, trade secrets, trademarks, patents, and other intellectual property. You also agree that you will not reproduce or redistribute the Grocji Pvt Ltd’s intellectual property in any way, including electronic, digital, or new trademark registrations.
                                <span class="policy-inner-text">
                                You grant Grocji Pvt Ltd a royalty-free and non-exclusive license to display, use, copy, transmit, and broadcast the content you upload and publish. For issues regarding intellectual property claims, you should contact the company in order to come to an agreement.
                                </span>
                            </p>
                        </div>
                        <div class="policy">
                            <h5 class="intro-heading">User accounts</h5>
                            <p class="policy-details">As a user of this website, you may be asked to register with us and provide private information. You are responsible for ensuring the accuracy of this information, and you are responsible for maintaining the safety and security of your identifying information. You are also responsible for all activities that occur under your account or password.

                                <span class="policy-inner-text">
                                If you think there are any possible issues regarding the security of your account on the website, inform us immediately so we may address them accordingly.
                                </span>

                                <span class="policy-inner-text">
                                We reserve all rights to terminate accounts, edit or remove content and cancel orders at our sole discretion.
                                </span>
                            </p>
                        </div>
                        <div class="policy">
                            <h5 class="intro-heading">Applicable law</h5>
                            <p class="policy-details">By using this website, you agree that the laws of the Gurgaon, Haryana, without regard to principles of conflict laws, will govern these terms and conditions, or any dispute of any sort that might come between Grocji Pvt Ltd and you, or its business partners and associates.
                            </p>
                        </div>
                        <div class="policy">
                            <h5 class="intro-heading">Disputes</h5>
                            <p class="policy-details">Any dispute related in any way to your use of this website or to products you purchase from us shall be arbitrated by state or federal court Gurgaon, Haryana and you consent to exclusive jurisdiction and venue of such courts.
                            </p>
                        </div>
                        <div class="policy">
                            <h5 class="intro-heading">Indemnification</h5>
                            <p class="policy-details">You agree to indemnify Grocji Pvt Ltd and its affiliates and hold Grocji Pvt Ltd harmless against legal claims and demands that may arise from your use or misuse of our services. We reserve the right to select our own legal counsel. 
                            </p>
                        </div>

                        <div class="policy">
                            <h5 class="intro-heading">Limitation on liability</h5>
                            <p class="policy-details">Grocji Pvt Ltd is not liable for any damages that may occur to you as a result of your misuse of our website.

                            <span class="policy-inner-text">
                            Grocji Pvt Ltd reserves the right to edit, modify, and change this Agreement at any time. We shall let our users know of these changes through electronic mail. This Agreement is an understanding between Grocji Pvt Ltd and the user, and this supersedes and replaces all prior agreements regarding the use of this website.
                                </span>
                            </p>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}
export default TermsandCondition;